export default __webpack_public_path__ + "static/media/Household-Appliances-mob.c82b24c3.jpg";